import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD3Zc8wbfyACG9DQBPeAl1G5VPcZr7emJg",
  authDomain: "customer-registration-25029.firebaseapp.com",
  projectId: "customer-registration-25029",
  storageBucket: "customer-registration-25029.firebasestorage.app",
  messagingSenderId: "1048313384797",
  appId: "1:1048313384797:web:98a0e829f8a6e2f2b2e2b4",
  measurementId: "G-KJTR9CBHNR",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

// Initialize counter collections
const initializeCounters = async () => {
  await setDoc(
    doc(db, "counters", "ocean"),
    { lastNumber: 0 },
    { merge: true }
  );
  await setDoc(doc(db, "counters", "air"), { lastNumber: 0 }, { merge: true });
};

initializeCounters();

export { db, storage, firebaseApp };
